// grid
export const WELL_ROW = 20
export const WELL_COL = 10
export const DROP_INTERVAL_DEFAULT = 600
export const DROP_INTERVAL_MIN = 250
export const DROP_INTERVAL_ACCELERATING = 30
export const DROP_INTERVAL_INC = 30
export const DROP_INTERVAL_DEC = 30
export const LINE_CLEAR_BONUS = [100, 200, 300, 400]

// keys
export const UP = 38
export const LEFT = 37
export const RIGHT = 39
export const DOWN = 40

export const GAME_INTRO = `This game is a simplified
 implementation(about 2K lines of code) of the famous
  game **Tetris**.<br /><br />If you are new to *React* or *MobX*,
   this could probably be a good choice where you could get your
    hands dirty. So do not forget to check the
     **[source code](https://github.com/thomasyimgit/Tetris)**.
      <br /><br />Thanks to **[@Rose](https://twitter.com/luosihua)** for
       this awesome UI design, without which this wouldn't
        come to the realization.<br /><br /> Built by
        **[@Chang](https://twitter.com/changyan33)**.`



// WEBPACK FOOTER //
// ./src/constants/options.js